<div class="color-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>palette</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Color</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content" [formGroup]="componentForm">
    <div class="form-row">
      <div class="form-group col-12">
        <div class="row m-auto">
          <div class="d-flex align-items-center col-md-12 p-0">
            <div class="col-md-6">Color </div>
            <div class="col-md-6">
              <div class="d-flex color-div">
                <input class="color-input form-control" type="text" [(colorPicker)]="color"
                  formControlName="color" [value]="color" id="color" (colorPickerChange)="onColorChange($event)">
                <div class="color-box" [style.background-color]="color"></div>
              </div>
            </div>
          </div>
        </div>
        <app-validation-error [formGroup]="componentForm" [controlName]="'color'"></app-validation-error>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-action" (click)="save()">
      <mat-icon>check_circle</mat-icon>
      Save
    </button>
  </div>
</div>
